module.exports = __webpack_public_path__ + "img/zoom-in.57394331.svg";